import { useMedia } from 'react-use'

export function useDeviceType() {
	const isMobile = useMedia('(max-width: 767px)', false)
	const isTablet = useMedia('(min-width: 768px) and (max-width: 1023px)', false)
	const isDesktop = useMedia('(min-width: 1024px)', false)

	return {
		isMobile,
		isTablet,
		isDesktop,
	}
}
